import { useCallback } from "react";

export function useNavigate() {
  const navigate = useCallback((url: string) => {
    if (window.top !== window.self) {
      window.parent?.postMessage({ type: "@endearhq/navigate", url }, "*");
    } else {
      window.location.assign(url);
    }
  }, []);

  return navigate;
}
